
import AOS from 'aos';

AOS.init({
	offset: 200,
	duration: 1000,
});